import React from "react";

const layers = [
  {
    top: -120,
    left: -140,
    size: 420,
    background:
      "radial-gradient(circle at 30% 30%, rgba(66,133,244,0.35) 0%, rgba(66,133,244,0.12) 42%, rgba(66,133,244,0) 72%)",
  },
  {
    top: 24,
    right: -120,
    size: 360,
    background:
      "radial-gradient(circle at 35% 35%, rgba(249, 249, 249, 0.26) 0%, rgba(242, 239, 232, 0.18) 34%, rgba(245, 240, 239, 0) 72%)",
  },
  {
    bottom: -140,
    left: "18%",
    size: 460,
    background:
      "radial-gradient(circle at 50% 50%, rgba(52,168,83,0.20) 0%, rgba(52,168,83,0.08) 38%, rgba(52,168,83,0) 70%)",
  },
];

const AuthShell = ({ children, mode = "center", plain = false }) => {
  const centered = mode === "center";

  return (
    <div
      style={{
        minHeight: "100vh",
        position: "relative",
        overflow: "hidden",
        display: "grid",
        placeItems: centered ? "center" : "center",
        padding: centered ? 24 : 32,
        background:
          plain
            ? "#F6FBF9"
            : "linear-gradient(135deg, #f8fbff 0%, #ffffff 38%, #fffef7 64%, #f8fff9 100%)",
      }}
    >
      {!plain && (
        <div
          aria-hidden="true"
          style={{
            position: "absolute",
            inset: 0,
            backgroundImage:
              "linear-gradient(rgba(15,23,42,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(15,23,42,0.03) 1px, transparent 1px)",
            backgroundSize: "72px 72px",
            maskImage: "linear-gradient(to bottom, rgba(0,0,0,0.55), rgba(0,0,0,0.08) 72%, transparent)",
            pointerEvents: "none",
          }}
        />
      )}

      {!plain &&
        layers.map((layer, index) => (
          <div
            key={index}
            aria-hidden="true"
            style={{
              position: "absolute",
              width: layer.size,
              height: layer.size,
              borderRadius: "999px",
              top: layer.top,
              right: layer.right,
              bottom: layer.bottom,
              left: layer.left,
              background: layer.background,
              filter: "blur(12px)",
              pointerEvents: "none",
            }}
          />
        ))}

      <div
        style={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          maxWidth: centered ? 520 : 1220,
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default AuthShell;
